<template>
  <v-chart ref="chart" :options="options" autoresize />
</template>

<script>
import Vue from 'vue';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/legend';

export default Vue.extend({
  components: {
    'v-chart': ECharts,
  },
  props: {
    deviceData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      graphData: [],
    };
  },
  computed: {
    options() {
      return {
        legend: {
          icon: 'circle',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: params => {
            return `${params[0].value[0]}%`;
          },
        },
        dataset: {
          source: this.graphData,
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          type: 'category',
        },
        grid: {
          containLabel: true,
        },
        color: ['#bfd8f5'],
        series: [
          {
            type: 'bar',
            barCategoryGap: '50%',
            encode: {
              y: 'device',
              x: 'value',
            },
          },
        ],
      };
    },
  },
  watch: {
    deviceData: {
      handler(val) {
        if (!val || !val.length) {
          this.graphData = [];
          return;
        }
        const data = val.map(i => {
          const value = i.ctr.toFixed(2);
          const device =
            i.device.substring(0, 1) + i.device.substring(1).toLowerCase();
          return [value, device];
        });
        const desktop = data.find(i => i[1] === 'Desktop');
        const mobile = data.find(i => i[1] === 'Mobile');
        const tablet = data.find(i => i[1] === 'Tablet');
        const other = data.find(i => i[1] === 'Other');
        const a = [['value', 'device']];
        if (other) {
          a.push(other);
        }
        if (tablet) {
          a.push(tablet);
        }
        if (mobile) {
          a.push(mobile);
        }
        if (desktop) {
          a.push(desktop);
        }
        this.graphData = a;
      },
      deep: true,
      immediate: true,
    },
  },
});
</script>

<style scoped></style>
